import { LOGO_URL, TELEGRAM_URL, PHONE, PHONE_TEL } from "../lib/config";
import { Send, Phone } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-border mt-12"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
                <div className="grid md:grid-cols-12 gap-10">
                    <div className="md:col-span-5">
                        <div className="flex items-center gap-3">
                            <img
                                src={LOGO_URL}
                                alt="High 95"
                                className="w-12 h-12 rounded-xl object-cover ring-1 ring-white/10 bg-white/5"
                            />
                            <div>
                                <p className="font-display font-bold text-white text-xl">
                                    HIGH95
                                </p>
                                <p className="font-mono text-[10px] text-white/50 uppercase tracking-widest mt-0.5">
                                    Premium THCA · NJ
                                </p>
                            </div>
                        </div>
                        <p className="mt-5 text-white/55 text-sm max-w-sm leading-relaxed">
                            Take High95.com to reach your destination in the
                            clouds. Local deliveries across South Jersey only.
                        </p>
                    </div>

                    <div className="md:col-span-3">
                        <p className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-4">
                            Navigate
                        </p>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <a
                                    href="#menu"
                                    className="text-white/70 hover:text-white"
                                >
                                    Menu
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#delivery"
                                    className="text-white/70 hover:text-white"
                                >
                                    Delivery
                                </a>
                            </li>
                            <li>
                                <a
                                    href="#contact"
                                    className="text-white/70 hover:text-white"
                                >
                                    Contact
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/admin"
                                    className="text-white/40 hover:text-white/70"
                                >
                                    Admin
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div className="md:col-span-4">
                        <p className="font-mono text-[10px] uppercase tracking-widest text-white/40 mb-4">
                            Reach Us
                        </p>
                        <a
                            data-testid="footer-telegram"
                            href={TELEGRAM_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="flex items-center gap-3 p-3 rounded-xl bg-card border border-border hover:border-highway-telegram/40 transition mb-3"
                        >
                            <Send className="w-4 h-4 text-highway-telegram" />
                            <span className="text-sm text-white">
                                Telegram channel
                            </span>
                        </a>
                        <a
                            data-testid="footer-phone"
                            href={`tel:${PHONE_TEL}`}
                            className="flex items-center gap-3 p-3 rounded-xl bg-card border border-border hover:border-highway-red/40 transition"
                        >
                            <Phone className="w-4 h-4 text-highway-red" />
                            <span className="text-sm text-white font-mono">
                                {PHONE}
                            </span>
                        </a>
                    </div>
                </div>

                <div className="mt-12 pt-8 border-t border-border flex flex-col md:flex-row justify-between gap-4 items-start md:items-center">
                    <p className="font-mono text-[10px] uppercase tracking-widest text-white/40">
                        © {new Date().getFullYear()} High95 · All rights
                        reserved
                    </p>
                    <p className="font-mono text-[10px] uppercase tracking-widest text-white/40 max-w-2xl text-right">
                        21+ only · Hemp-derived THCA · Federally compliant ·
                        Keep out of reach of children · Do not drive under
                        influence
                    </p>
                </div>
            </div>
        </footer>
    );
}
